import { ActionIcon, Badge, Button, Group, Tooltip } from '@mantine/core'
import { IconCircleCheckFilled, IconExternalLink } from '@tabler/icons-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { VP_DOCS_URL } from '@/config/main'

type EdgeClientVersionBadgeProps = {
  version?: string
  latestVersion?: string
  isLatest?: boolean
  showInstallButton?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  onUpdate?: () => void
}

export const EdgeClientVersionBadge = ({
  version,
  latestVersion,
  isLatest,
  showInstallButton,
  isDisabled,
  isLoading,
  onUpdate
}: EdgeClientVersionBadgeProps) => {
  const intl = useIntl()

  return (
    <Group wrap="nowrap" gap="xs" align="center">
      {version && (
        <Badge size="sm" color="gray">
          {version}
        </Badge>
      )}

      {isLatest && (
        <IconCircleCheckFilled size={18} color="var(--mantine-color-green-6)" />
      )}

      {!isLatest && showInstallButton && latestVersion && (
        <Button
          size="compact-xs"
          variant="outline"
          loading={isLoading}
          disabled={isDisabled}
          onClick={onUpdate}
        >
          <FormattedMessage
            id="devices.edgeClient.installUpdate"
            values={{ version: latestVersion }}
          />
        </Button>
      )}

      {!isLatest && showInstallButton && latestVersion && (
        <Tooltip
          label={<FormattedMessage id="devices.edgeClient.releaseNotes" />}
        >
          <ActionIcon
            component="a"
            href={`${VP_DOCS_URL}/edge-hardware/release-notes`}
            target="_blank"
            rel="noopener noreferrer"
            variant="subtle"
            size="sm"
            radius="xl"
            aria-label={intl.formatMessage({
              id: 'devices.edgeClient.releaseNotes'
            })}
          >
            <IconExternalLink style={{ width: '70%', height: '70%' }} />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  )
}
